export default "__VITE_ASSET__BLySF435__"